import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=3c8022f8&"
import script from "./domain.vue?vue&type=script&lang=js&"
export * from "./domain.vue?vue&type=script&lang=js&"
import style0 from "./domain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports